import upperFirst from 'lodash/upperFirst';
import brazilStatesEnum from '@/utils/enums/brazilStates.enum';
import flowStepsEnum from '@/utils/enums/flowSteps.enum';

const getters = {
  hasTeamName(state) {
    return state.teamName !== null;
  },

  hasCompletedFlow(state, getters, rootState) {
    const { status } = rootState.currentAdmission.data;
    const isStatusDone = ['CHECK_IN_DONE', 'ADMISSION_DONE'].includes(status);

    return { isStatusDone, status };
  },

  userFirstName(state, getters, rootState) {
    const { name } = rootState.mdm.data;
    const firstName = name?.split(' ')[0] || 'Paciente';

    return upperFirst(firstName);
  },

  getBrazilStateFullname() {
    return (brazilState) => brazilStatesEnum[brazilState] || '';
  },

  flowStepsList(state, getters, rootState) {
    const origin = rootState.currentAdmission.origin;

    let flowSteps = [...state.flowSteps];

    // Checks if the "payment status" step (insurance authorized or private) already exists in the step flow
    const hasPaymentStatus = flowSteps.some((flowStep) => flowStep[0] === 7 || flowStep[0] === 8);

    const stepRemaining = {
      // Adds "check exams" step to stepRemaing if it does not exist in flowSteps
      exams: flowSteps.some((flowStep) => flowStep[0] === 2) ? null : [2, 1],

      // Adds "payment status" step (insurance authorized or private) to stepRemaing if it does not exist in flowSteps
      paymentStatus: hasPaymentStatus
        ? null
        : flowSteps.some((flowStep) => flowStep[0] === 4)
          ? [7, 1]
          : [8, 1],

      // Adds "protocols signing" step to stepRemaing
      signature: [9, 1],
    };

    const selectExamsWithoutSchedule = origin === 'AUT' && this.isT2FlowAllowed;

    if (stepRemaining.exams && !selectExamsWithoutSchedule) {
      flowSteps.push(stepRemaining.exams);
    }

    if (stepRemaining.paymentStatus) {
      flowSteps.push(stepRemaining.paymentStatus);
    }

    if (!getters.isT2FlowAllowed) {
      flowSteps.push(stepRemaining.signature);
    }

    if (getters.isCollaboratorFlow) {
      flowSteps = [
        [1, 2],
        [10, 2],
        [11, 1],
      ];
    }

    if (getters.isVaccineFlow) {
      const { status } = rootState.currentAdmission.data.payments[0];
      const isPaid = status === 'PAID' ? 2 : 1;
      flowSteps = [
        [1, 2],
        [12, isPaid],
        [11, 1],
      ];
    }

    if (state.isAdmissionAuthorized) {
      flowSteps = [
        [1, 2],
        [3, 2],
        [4, 2],
        [7, 2],
        [10, 2],
      ];
      if (state.hasSurvey) {
        const questionnariesStep = this.flowSteps.find((steps) => steps[0] === 11);
        const questionnariesStatus = questionnariesStep ? questionnariesStep[1] : 1;
        flowSteps.push([11, questionnariesStatus]);
      }
    }

    return flowSteps.map((flowStep) => {
      const [stepIndex, statusIndex] = flowStep;
      const name = flowStepsEnum.step[stepIndex] || '';
      const status = flowStepsEnum.status[statusIndex] || '';

      return {
        name,
        status,
      };
    });
  },

  isT2FlowAllowed(state) {
    return state.isT2FlowAllowed;
  },

  isOnlinePaymentEnabled(state) {
    return state.isOnlinePaymentEnabled;
  },

  isScheduledAdmission(state) {
    return state.isScheduledAdmission;
  },

  isElegibleToBypassToPayment(state) {
    return state.isElegibleToBypassToPayment;
  },

  isVaccineFlow(state) {
    return state.isVaccineFlow;
  },

  admissionFlows(state) {
    return state.admissionFlows;
  },

  getEndMessageByFlow(state) {
    return state.getEndMessageByFlow;
  },

  isCollaboratorFlow(state) {
    return state.isCollaboratorFlow;
  },

  isNav(state) {
    return state.isNav;
  },

  navLogo(state) {
    return state.navLogo;
  },

  isFlowStartedWithPaymentChoice(state) {
    return state.isFlowStartedWithPaymentChoice;
  },

  amilTokensToValidate(state) {
    return state.amilTokensToValidate;
  },

  getGlobalState(state) {
    return state;
  },

  isBradescoFlowSuccess(state) {
    return state.isBradescoFlowSuccess;
  },
};

export default getters;
